import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import Home from '../views/Home.vue';
import WaitingRoom from '../views/WaitingRoom.vue';
import TherapyRoom from '../views/TherapyRoom.vue';
import RecuperRoom from '../views/RecuperRoom.vue';
import Login from '../views/Login.vue';
import ImageAlpha from '../views/ImageAlpha.vue';
import ChatView from '../views/ChatView.vue';
import ChatMenu from '../views/ChatMenu.vue';
import TherapyView from '../views/TherapyView.vue';
import TherapyMenu from '../views/TherapyMenu.vue';
import UserView from '../views/UserView.vue';
import DefaultView from '../views/DefaultView.vue';
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: async (to, from, next) => {
      //geen logout om de POST te vermijden.
      await store.commit('clearUser');
      next();
    },
  },
  {
    path: '/waitingroom',
    name: 'WaitingRoom',
    component: WaitingRoom,
  },
  {
    path: '/therapyroom',
    name: 'TherapyRoom',
    component: TherapyRoom,
    beforeEnter: async (to, from, next) => {
      if (store.state.myroom != 'therapyroom') {
        router.push({ name: 'Home' });
      }
      next();
    },
  },
  {
    path: '/recuperroom',
    name: 'RecuperRoom',
    component: RecuperRoom,
    beforeEnter: async (to, from, next) => {
      if (store.state.myroom != 'recuperroom') {
        router.push({ name: 'Home' });
      }
      next();
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/imagealpha',
    name: 'ImageAlpha',
    component: ImageAlpha,
    meta: {
      inNav: true,
      requiresLogin: true,
    },
  },
  {
    path: '/user',
    component: UserView,
    name: 'UserView',
    props: true,
    meta: {
      inNav: true,
      requiresLogin: true,
    },
  },

  {
    path: '/therapy',
    component: DefaultView,
    name: 'Therapy',
    meta: {
      inNav: true,
      requiresLogin: true,
    },
    children: [
      {
        path: '',
        name: 'TherapyMenu',
        component: TherapyMenu,
        props: true,
      },
      {
        path: ':therapy_id',
        name: 'TherapyView',
        component: TherapyView,
        props: true,
      },
    ],
  },
  {
    path: '/chat',
    component: DefaultView,
    name: 'Chat',
    meta: {
      inNav: true,
      requiresLogin: true,
    },
    children: [
      {
        path: '',
        name: 'ChatMenu',
        component: ChatMenu,
        props: true,
      },
      {
        path: ':chat_id',
        name: 'ChatView',
        component: ChatView,
        props: true,
      },
    ],
  },
  {
    path: '/logout',
    name: 'Logout',
    meta: {
      inNav: true,
    },
    beforeEnter: async (to, from, next) => {
      await store.dispatch('logOut');
      next('/');
    },
  },
];

/* BASE_URL komt uit vite.config.js, waarde 'base'*/
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!store.getters.isLoaded) {
    try {
      await store.dispatch('mount');
    } catch (e) {
      console.log(e);
    }
  }
  if (!store.getters.isLoggedIn && to.meta.requiresLogin) {
    next('/login');
    return;
  }
  next().catch((e) => {
    console.log(e);
  });
});

export default router;
